import { Component, OnInit, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';

import {
  DEFAULT_LANG,
  IDLE_SECONDS,
  TIMEOUT_PERIOD_SECONDS,
} from '../constants/app-constants';
import { BLANK_ROUTE } from '../constants/app-url-constants';
import { AuthServerProvider } from './auth/auth-jwt.service';
import { ScriptService } from './shared/services/script.service';
import { environment } from '../environments/environment';

declare var gtag;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  title = 'SeasonOne';
  isSpinnerVisible: boolean;
  timedOut = false;
  lastPing?: Date = null;

  constructor(
    translate: TranslateService,
    private idle: Idle,
    keepalive: Keepalive,
    private authServerProviderService: AuthServerProvider,
    private router: Router,
    private $localStorage: LocalStorageService,
    private scriptService: ScriptService,
    private renderer: Renderer2
  ) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        window.scroll(0, 0);
      }
    });

    translate.setDefaultLang(DEFAULT_LANG);

    const selectedLanguage = this.$localStorage.retrieve('selectedLanguage');
    if (selectedLanguage && selectedLanguage.match(/en-US|en-CA|fr-CA/)) {
      translate.use(selectedLanguage);
    }

    // sets an idle timeout of 5 seconds, for testing purposes.
    idle.setIdle(IDLE_SECONDS);
    // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
    idle.setTimeout(TIMEOUT_PERIOD_SECONDS);
    // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
    idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

    idle.onTimeout.subscribe(() => {
      this.idle.watch();
      this.authServerProviderService.logout().subscribe();
      this.router.navigate([BLANK_ROUTE]);
    });

    // sets the ping interval to 15 seconds
    keepalive.interval(15);

    keepalive.onPing.subscribe(() => (this.lastPing = new Date()));

    this.reset();

    this.injectKitbuilderScript();
    this.injectDriveCommerceScript();
  }

  reset() {
    this.idle.watch();
    this.timedOut = false;
  }

  injectKitbuilderScript() {
    const scriptElement = this.scriptService.loadJsScript(
      this.renderer,
      environment.KITBUILDER_SCRIPT_URL
    );
    scriptElement.onload = () => {
      console.log('Kitbuilder Script loaded');
    };
    scriptElement.onerror = () => {
      console.log('Could not load the Kitbuilder Script Script!');
    };
  }

  injectDriveCommerceScript() {
    const scriptElement = this.scriptService.loadJsScript(
      this.renderer,
      environment.DRIVE_COMMERCE_SCRIPT_URL
    );
    scriptElement.onload = () => {
      console.log('Drive Commerce Script loaded');
    };
    scriptElement.onerror = () => {
      console.error('Could not load the Drive Commerce Script!');
    };
  }

  ngOnInit() {}
}
